export default __webpack_public_path__ + "static/media/photo--sm--95.f160d5d4.jpg";